const el = (tag, ...children) => {
  const e = document.createElement(tag);
  children.forEach(child => {
    if (typeof child === 'string') {
      const t = document.createTextNode(child);
      e.appendChild(t);
    } else {
      e.appendChild(child);
    }
  });
  return e;
};

const openRetry = () => {
  const e = document.createElement('aside');
  e.innerHTML =
    '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-alert-triangle"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path><line x1="12" y1="9" x2="12" y2="13"></line><line x1="12" y1="17" x2="12" y2="17"></line></svg> Login failed <span> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-refresh-cw"><polyline points="23 4 23 10 17 10"></polyline><polyline points="1 20 1 14 7 14"></polyline><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path></svg> </span>';

  e.classList.add('_alert');
  e.onclick = () => {
    window.location.href = 'http://localhost:1234/#edit';
    location.reload();
  };
  document.body.prepend(e);
};

export default openRetry;
